import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContactFormService {
  private openFormSubject = new Subject<string>();
  openForm$ = this.openFormSubject.asObservable();

  openForm(source: string) {
    this.openFormSubject.next(source);
  }
}
